/**
 * INTERNAL ONLY
 * Do not use this outside of `data-access`.
 * Use `withPrefersReducedMotion` instead.
 */
import type * as React from "react";

import {useRenderState} from "@khanacademy/wonder-blocks-core";
import {preferReducedMotion} from "@khan/data-prefers-reduced-motion/prefer-reduced-motion";
import {useUserAttributes} from "@khan/shared-core";

interface Props {
    children: (prefersReducedMotion: boolean) => React.ReactNode;
}

const PrefersReducedMotion = ({children}: Props): React.ReactNode => {
    const userAttributes = useUserAttributes();
    const renderState = useRenderState();
    return children(
        renderState !== "standard" || preferReducedMotion(userAttributes),
    );
};

export default PrefersReducedMotion;
